// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o-uJb","title":"styles_title__3gUMo"};